import { getAttrValue, isPlainObject, getLocalizedValue, getLocalizedValues } from '@grandvisionhq/utils';

const getLocalizedAttribute = (variant, attrName, locale, seperator = ', ')=>{
    const attrValue = getAttrValue(variant, attrName);
    if (isPlainObject(attrValue)) {
        /* Handle two different types of attribute values

        value: {
          key: 'aviator',
          label: {
            'en': 'Aviator',
        }

        },
        value: {
          en: 'Gold,Violet',
        },
      */ const obj = attrValue;
        var ref;
        const value = (ref = obj === null || obj === void 0 ? void 0 : obj.label) !== null && ref !== void 0 ? ref : attrValue;
        return getLocalizedValue(value, locale);
    }
    if (Array.isArray(attrValue)) {
        var ref1;
        var ref2;
        return (ref2 = (ref1 = getLocalizedValues(attrValue, locale)) === null || ref1 === void 0 ? void 0 : ref1.join(seperator)) !== null && ref2 !== void 0 ? ref2 : '';
    }
};

export { getLocalizedAttribute };
//# sourceMappingURL=get-line-item-localized-attribute.js.map
